export const BADGE_CLASS_NAME = 'kurama-badge'
